/**
 * 添付領収書 panel for the travel-expense form. Screen-only (no-print).
 * Rendered OUTSIDE the form's overlay container so it never inflates the
 * signature/text annotation positioning box (which must equal the form sheet
 * height in both screen and print for WYSIWYG).
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const RECEIPT_API = `${BACKEND_URL}/api/receipts`;

export default function TravelReceiptsPanel({ submission }) {
  const data = submission.form_data || {};
  const allReceipts = [];
  const seen = new Set();
  const pushUnique = (r) => {
    if (r && r.id && !seen.has(r.id)) { seen.add(r.id); allReceipts.push(r); }
  };
  (data.receipts || []).forEach(pushUnique);
  (data.transport_legs || []).forEach((l) => (l.receipts || []).forEach(pushUnique));
  (data.other_receipts || []).forEach(pushUnique);
  const receipts = allReceipts;
  if (receipts.length === 0) return null;

  return (
    <div className="no-print" style={{ marginTop: '16px', padding: '12px 16px', background: '#fafafa', border: '1px solid #e4e4e7', borderRadius: '8px' }} data-testid="travel-receipts-panel">
      <div style={{ fontSize: '12px', fontWeight: 'bold', color: '#333', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
        <span>添付領収書（{receipts.length} 件）</span>
        <span style={{ fontSize: '10px', fontWeight: 'normal', color: '#666' }}>※ 各PDFをクリックすると印刷ダイアログが開きます</span>
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
        {receipts.map((r, idx) => (
          <button
            key={r.id || idx}
            type="button"
            onClick={() => {
              const url = `${RECEIPT_API}/${r.id}`;
              const frame = document.createElement('iframe');
              frame.style.position = 'fixed';
              frame.style.right = '-9999px';
              frame.style.bottom = '0';
              frame.style.width = '0';
              frame.style.height = '0';
              frame.style.border = '0';
              frame.src = url;
              frame.onload = () => {
                try { frame.contentWindow.focus(); frame.contentWindow.print(); }
                catch (_) { window.open(url, '_blank'); }
              };
              document.body.appendChild(frame);
              setTimeout(() => { try { document.body.removeChild(frame); } catch (_) { /* ignore */ } }, 60000);
            }}
            title={`${r.filename}を印刷`}
            style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
              width: '120px', padding: '10px 6px',
              background: '#fff', border: '1px solid #d4d4d8', borderRadius: '6px',
              cursor: 'pointer', transition: 'all 0.15s',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#0052FF'; e.currentTarget.style.background = '#f0f5ff'; }}
            onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#d4d4d8'; e.currentTarget.style.background = '#fff'; }}
          >
            <svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginBottom: '4px' }}>
              <path d="M4 0h18l8 8v28a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z" fill="#dc2626"/>
              <path d="M22 0v8h8L22 0z" fill="#fca5a5"/>
              <text x="16" y="26" textAnchor="middle" fill="#fff" fontSize="8" fontWeight="bold" fontFamily="Arial, sans-serif">PDF</text>
            </svg>
            <span style={{ fontSize: '10px', fontWeight: 'bold', color: '#27272a', maxWidth: '108px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {r.filename || `receipt-${idx + 1}.pdf`}
            </span>
            <span style={{ fontSize: '9px', color: '#71717a', marginTop: '1px' }}>
              {r.orientation === 'landscape' ? '横向き' : '縦向き'}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
